// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetailsEditButton_container__H8akS","container-ltr":"OrderDetailsEditButton_container-ltr__3qkUE"};